function InfoStats() {
    return (
        <div className="info-stats">
            <div className="stat-one">
                <p className="stat-one-number">20%</p>
                <p className="stat-text">of the wastewater world wide is attributed to fashion industry</p>
            </div>
            <div className="stat-two">
                <p className="stat-two-number">24</p>
                <p className="stat-text">pounds of greenhouse gasses emitted with every gallon of gas</p>
            </div>
            <div className="stat-three">
                <p className="stat-three-number">80%</p>
                <p className="stat-text">of water systmes in America have been found with contaminants linked to cancer</p>
            </div>
        </div>
    )
}

export default InfoStats